import { useMemo } from 'react';
import { useFilterContext } from 'src/contexts/FilterContext';
import { useSelectedDimensionContext } from '../contexts/SelectedDimensionContext';
import { Dimension } from '../types';

export const useByDimensionNameAndId = () => {
  const { dimension } = useSelectedDimensionContext();

  const { campaigns, media, campaignGroups } = useFilterContext();

  return useMemo(() => {
    switch (dimension) {
      case Dimension.campagin:
        return campaigns
          .filter((c) => c.selected)
          .map((c) => ({ name: c.name, id: c.id }));
      case Dimension.media:
        return media
          .filter((m) => m.selected)
          .map((m) => ({ name: m.name, id: m.id }));
      case Dimension.campaignGroup:
        return campaignGroups
          .filter((g) => g.selected)
          .map((g) => ({ name: g.groupName, id: g.id }));
    }
  }, [dimension, campaigns, media, campaignGroups]);
};
